import { EnhancedLink } from '@/components/EnhancedLink';
import { useEnhancedRouter } from '@/hooks/useEnhancedRouter';
import { useTranslations } from '@/hooks/useTranslations';
import { parseText } from '@/utils/parseText';
import cn from 'classnames';
import styles from './PaginationRoutes.module.scss';

type PaginationRoutesProps = {
  routes: {
    link: string;
    text: string;
  }[];
  className?: string;
};

export function PaginationRoutes({ routes, className }: PaginationRoutesProps) {
  const { push, asPath, query } = useEnhancedRouter();
  const paginationClassName = cn(styles.pagination, className);
  const translations = useTranslations();

  const handleRouteClick = (link: string) => {
    if (
      asPath === link ||
      `${asPath}/` === link ||
      asPath.split('?')[0] === link
    ) {
      return;
    }

    if (Object.values(query)[0] === link) {
      return;
    }

    push(link);
  };

  return (
    <div className={paginationClassName}>
      <EnhancedLink className={styles.route} href={'/'}>
        {translations.home}{' '}
      </EnhancedLink>
      {routes.map((route) => (
        <span
          key={route.text}
          onClick={() => handleRouteClick(route.link)}
          className={`${styles.route} ${
            asPath === route.link || `${asPath}/` === route.link
              ? styles.nonClick
              : ''
          }`}
        >
          {' '}
          / {parseText(route.text)}
        </span>
      ))}
    </div>
  );
}
